export default __webpack_public_path__ + "static/media/musee-atelier-audemars-piguet_2000.3e581bac.png";